// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"764":"7cdec154","978":"de8e9ce5"}[chunkId] + ".chunk.js";
};